import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import styles from './Radio.module.scss'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  labelDescription?: string
  error?: string
  allowUncheck?: boolean
  // Optional feature checklist rendered by RadioGroupCards beneath the radio when used as a card.
  // Ignored by Radio itself.
  features?: { label: string; included?: boolean }[]
}

const Radio = ({
  label,
  labelDescription,
  error,
  onChange,
  checked,
  allowUncheck = true,
  features,
  ...props
}: Props) => {
  const { disabled, id } = props
  const [isChecked, setIsChecked] = useState(checked)
  const [isFocused, setIsFocused] = useState(false)

  useEffect(() => {
    setIsChecked(checked)
  }, [checked])

  const handleChange = (e: any) => {
    const { checked } = e.target
    if (!isChecked || allowUncheck) {
      setIsChecked(!checked)
      if (typeof onChange === 'function') {
        const newEvent = { ...e, checked }
        onChange(newEvent)
      }
    }
  }

  const handleFocus = (e: any) => {
    if (props.onFocus) {
      props.onFocus(e)
    }

    setIsFocused(true)
  }

  const handleBlur = (e: any) => {
    if (props.onBlur) {
      props.onBlur(e)
    }

    setIsFocused(false)
  }

  const classes = classNames(styles.root, {
    [styles['is-focused']]: isFocused,
    [styles['is-checked']]: isChecked,
    [styles['has-error']]: error,
    [styles['is-disabled']]: disabled,
    [styles['has-description']]: labelDescription,
  })

  return (
    <div className={classes}>
      {label && (
        <label htmlFor={id}>
          <input
            {...props}
            type="radio"
            checked={isChecked}
            onChange={handleChange}
            onClick={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          <span className={styles['label-text']}>
            {label}
            {error && ` - ${error}`}
          </span>
          {labelDescription && <span className={styles['label-description']}>{labelDescription}</span>}
        </label>
      )}
    </div>
  )
}

export default Radio
